import { faBell, faBuildingColumns, faChartLine, faCircleRight, faHome, faLock, faRectangleList, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Buffer } from 'buffer';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../mcss/menu.css';
import * as Common from "./Common";
import Stock_valuation_model from './Stock_valuation_model';

function Menu() {
    const navigate = useNavigate();

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [allRight, setAllRight] = useState([]);
    const [showStockValuation, setShowStockValuation] = useState(false);
    const [notification, setNotification] = useState(false);
    const [balanceSheetRight, setbalanceSheetRight] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'allrightquery'], function (result) {
                let base64ToString;
                let resp;
                let resp1;
                try {
                    base64ToString = Buffer.from(result, "base64").toString();
                    resp = JSON.parse(base64ToString);
                } catch (error) {
                    resp = JSON.parse('{"LOGOUT": ""}');
                }
                try {
                    resp1 = JSON.parse(result);
                } catch (error) {
                    resp1 = JSON.parse('{"status": ""}');
                }
                setAllRight(resp);
                Common.callApi(Common.apiRight, [sid, 'all', 'REP_BALANCE_SHEET'], function (result) {
                    let resp = JSON.parse(result);
                    setbalanceSheetRight(resp);
                });
                console.log(resp);
                if (resp.LOGOUT === "0" || resp1.status === "MSG0002") {
                    navigate('/');
                }
            });
            setOnceRun(true);
            checkNotificaiton();
        }
    }, [onceRun, sid]);

    function goToPage(id) {
        checkSessionFinYear();
        clearInterval(sessionStorage.myInterval);
        //Common.setPageTitle(0);
        switch (id) {
            case 0:
                sessionStorage.clear();
                navigate('/');
                break;
            case 'home':
                navigate('/home');
                break;
            case 'userlist':
                navigate('/user-list');
                break;
            case 'right':
                navigate('/right-list');
                break;
            case 'country':
                navigate('/country-list');
                break;
            case 'city':
                navigate('/city-list');
                break;
            case 'state':
                navigate('/state-list');
                break;
            case 'district':
                navigate('/district-list');
                break;
            case 'issuer':
                navigate('/issuer-list');
                break;
            case 'purpose':
                navigate('/purpose-list');
                break;
            case 'currency':
                navigate('/isd-list');
                break;
            case 'idtype':
                navigate('/id-type');
                break;
            case 'dealer':
                navigate('/dealer-list');
                break;
            case 'vouchergroup':
                navigate('/voucher-group');
                break;
            case 'voucherledger':
                navigate('/voucher-ledger');
                break;
            case 'voucherledgerview':
                navigate('/voucher-ledger-view');
                break;
            case 'region':
                navigate('/region-list');
                break;
            case 'countryclass':
                navigate('/country-class');
                break;
            case 'division':
                navigate('/division-list');
                break;
            case 'risk':
                navigate('/risk-list');
                break;
            case 'businessnature':
                navigate('/business-nature');
                break;
            case 'legalentity':
                navigate('/legal-entity');
                break;
            case 'costcenter':
                navigate('/cost-center');
                break;
            case 'gstclassification':
                navigate('/gst-classification');
                break;
            case 'msme':
                navigate('/msme');
                break;
            case 'designation':
                navigate('/designation');
                break;
            case 'executive':
                navigate('/executive');
                break;
            case 'sub_executive':
                navigate('/sub-executive');
                break;
            case 'vouchertype':
                navigate('/voucher-type');
                break;
            case 'purchasepublic':
                navigate('/purchase-from-public');
                break;
            case 'purchasebulk':
                navigate('/purchase-bulk');
                break;
            case 'individualprofile':
                navigate('/individual-profile');
                break;
            case 'groupdoc':
                navigate('/group-doc');
                break;
            case 'finyear':
                navigate('/financial-year');
                break;
            case 'sampleform':
                navigate('/sampleform');
                break;
            case 'trial':
                navigate('/tran-opn-trial');
                break;
            case 'residentialstatus':
                navigate('/residential-status');
                break;
            case 'cmrcmp':
                navigate('/tran-opn-cmrcmp');
                break;
            case 'stock':
                navigate('/tran-currency-stock');
                break;
            case 'vtm':
                navigate('/tran-opn-vtc');
                break;
            case 'bankstatement':
                navigate('/opn-bank-statement');
                break;
            case 'tc':
                navigate('/tran-opn-tc');
                break;
            case 'etc':
                navigate('/tran-opn-etc');
                break;
            case 'vtmencash':
                navigate('/vtm-encashment');
                break;
            case 'evtm':
                navigate('/tran-opn-evtm');
                break;
            case 'tc-settlement':
                navigate('/tc-settlement');
                break;
            case 'vtm-settlement':
                navigate('/vtm-settlement');
                break;
            case 'chequebookin':
                navigate('/cheque-book-in');
                break;
            case 'fa-book-entry':
                navigate('/fa-book-entry');
                break;
            case 'salespublic':
                navigate('/sale-public');
                break;
            case 'transfer-vtc':
                navigate('/transfer-vtc');
                break;
            case 'chequedeposit':
                navigate('/cheque-deposit');
                break;
            case 'chequebookout':
                navigate('/cheque-book-out');
                break;
            case 'chequebounce':
                navigate('/received-cheque-bounce');
                break;
            case 'issuechequebounce':
                navigate('/issue-cheque-bounce');
                break;
            case 'bankreconciliation':
                navigate('/bank-reconciliation');
                break;
            case 'testing':
                navigate('/testing');
                break;
            case 'manual-book':
                navigate('/manual-book');
                break;
            case 'ledger':
                navigate('/ledger');
                break;
            case 'salebulk':
                navigate('/sale-bulk');
                break;
            case 'trialbalance':
                navigate('/trial-balance');
                break;
            case 'transferoutvtc':
                navigate('/out-vtc');
                break;
            case 'transeroutcurrency':
                navigate('/out-currency');
                break;
            case 'acceptinterbranch':
                navigate('/accept-interbranch')
                break;
            case 'repfinrecvbillwisedetail':
                navigate('/rep-fin-recv-bill-wise-detail');
                break;
            case 'ledgerlink':
                navigate('/ledger-link');
                break;
            case 'chequeinhandreport':
                navigate('/cheque-in-hand-report');
                break;
            case 'chequeusedreport':
                navigate('/cheque-used-report')
                break;
            case 'ib-entry':
                navigate('/ib-entry')
                break;
            case 'margin':
                navigate('/margin');
                break;
            case 'ibr':
                navigate('/ibr');
                break;
            case 'dataunlock':
                navigate('/data-unlock');
                break;
            case 'transactionreport':
                navigate('/transaction-report');
                break;
            case 'currencywriteoff':
                navigate('/currency-writeoff');
                break;
            case 'purchaseinvoice':
                navigate('/purchase-invoice');
                break;
            case 'globalvtmsettle':
                navigate('/global-vtm-settlement');
                break;
            case 'currencychange':
                navigate('/currency-change');
                break;
            case 'cancellation':
                navigate('/cancellation');
                break;
            case 'entity':
                navigate('/entity');
                break;
            case 'settlement-vtm':
                navigate('/settlement-vtm');
                break;
            case 'expense-transfer':
                navigate('/expense-transfer');
                break;
            case 'internal-fund-transfer':
                navigate('/internal-fund-transfer');
                break;
            case 'stockinhandreport':
                navigate('/stock-in-hand-report');
                break;
            case 'manualbookreport':
                navigate('/manual-book-report');
                break;
            case 'fundConfirmation':
                navigate('/fund-confirmation');
                break;
            case 'masterdsr':
                navigate('/master-dsr');
                break;
            case 'flmreport':
                navigate('/flm-report');
                break;
            case 'fxdocument':
                navigate('/fx-document');
                break;
            case 'evtmsurrender':
                navigate('/evtm-surrender');
                break;
            case 'commission':
                navigate('/commission-module');
                break;
            case 'conveyance':
                navigate('/conveyance-module');
                break;
            case 'tranmodulepayment':
                navigate('/tran-module-payment');
                break;
            case 'agentlinking':
                navigate('/agent-linking');
                break;
            case 'chngpass':
                navigate('/changepassword');
                break;
            case 'billwisedetailpayable':
                navigate('/bill-wise-detail-payable');
                break;
            case 'commissiontds':
                navigate('/commission-tds');
                break;
            case 'tranpaymentreport':
                navigate('/tran-payment-report');
                break;
            case 'repdashboard':
                navigate('/rep-dashboard');
                break;
            case 'activityreport':
                navigate('/activity-log-report')
                break;
            case 'additionallimit':
                navigate('/additional-limit')
                break;
            case 'ratecard':
                navigate('/rate-card')
                break;
            case 'repcommissionstatus':
                navigate('/commission-status')
                break;
            case 'transactionmodification':
                navigate('/transaction-modification')
                break;
            case 'tranmodificationcommission':
                navigate('/modification-commission')
                break;
            case 'tranmodificationdate':
                navigate('/modification-date')
                break;
            case 'saleinvoice':
                navigate('/sale-invoice')
                break;
            case 'tranmodificationpayment':
                navigate('/payment-modification');
                break;
            case 'sourceoffund':
                navigate('/source-of-fund');
                break;
            case 'allbank':
                navigate('/master_bank_all');
                break;
            case 'masterbudget':
                navigate('/master-budget');
                break;
            case 'masterbudgetexecutive':
                navigate('/master-budget-executive');
                break;

            case 'vtmsettlementreportglobal':
                navigate('/vtm-settlement-report-global', { state: { dropdownType: 'GLOBAL' } });
                break;
            case 'vtmsettlementreportlocal':
                navigate('/vtm-settlement-report-local', { state: { dropdownType: 'LOCAL' } });
                break;
            case 'vtmutilization':
                navigate('/vtm-utilization');
                break;
            case 'repchequeutilization':
                navigate('/cheque-utilization');
                break;
            case 'repoutstandingcmrp':
                navigate('/outstanding-cmrp');
                break;
            case 'vtmactivation':
                navigate('/vtm-activation');
                break;
            default:
                navigate('/');
                break;
            case 'mastervisatype':
                navigate('/master_visa_type');
                break;
            case 'crossknockoff':
                navigate('/tran-cross-knockoff');
                break;
            case 'knockoffview':
                navigate('/tran_knockoff_view');
                break;
            case 'salesad2':
                navigate('/sales_ad_ii');
                break;
            case 'repvtmprofitabilitylocal':
                navigate('/rep-vtm-profitability-local', { state: { dropdownType: 'LOCAL' } });
                break;
            case 'repvtmprofitabilityglobal':
                navigate('/rep-vtm-profitability-global', { state: { dropdownType: 'GLOBAL' } });
                break;
            case 'repvaluationlocal':
                navigate('/rep-valuation-local', { state: { dropdownType: 'LOCAL' } });
                break;
            case 'repvaluationglobal':
                navigate('/rep-valuation-global', { state: { dropdownType: 'GLOBAL' } });
                break;
            case 'rbipurchasestatementreport':
                navigate('/rep-rbi-purchase-statement');
                break;
            case 'rbiturnoverreport':
                navigate('/rep-rbi-turnover');
                break;
            case 'gstreport':
                navigate('/rep-gst');
                break;
            case 'balancesheet':
                navigate('/balance-sheet');
                break;
            case 'transferoutissuervtc':
                navigate('/out-issuer-vtc');
                break;
            case 'sftpreport':
                navigate('/rep-sftp');
                break;
            case 'repprofitabilitytransaction':
                navigate('/rep-profitability-transaction');
                break;
            case 'repprofitabilitycontribution':
                navigate('/rep-profitability-contribution');
                break;
            case 'mastersanctionheader':
                navigate('/master-sanction-header');
                break;
            case 'vtmstatusreport':
                navigate('/vtm-status-report')
                break;
            case 'purchaseadII':
                navigate('/purchase-adii')
                break;
            case 'stockvaluation':
                navigate('/rep-stock-valuation')
                break;
            case 'vtminout':
                navigate('/rep-vtm-in-out')
                break;
            case 'tellersheet':
                navigate('/rep-teller-sheet')
                break;
            case 'repchequereceived':
                navigate('/cheque-received')
                break;
            case 'vtm-in-view':
                navigate('/vtm-in-view');
                break;
            case 'currency-in-view':
                navigate('/currency-in-view');
                break;
            case 'cheque-in-view':
                navigate('/cheque-in-view');
                break;
            case 'knockoffreport':
                navigate('/knockoff-report');
                break;
            case 'repchequestatus':
                navigate('/cheque-status');
                break;
            case 'tcsreport':
                navigate('/rep-tcs');
                break;
            case 'riskconfiguration':
                navigate('/risk-configuration');
                break;
            case 'sanctionsapproval':
                navigate('/sanctions-approval');
                break;
            case 'tcseligibiliy':
                navigate('/tcs-eligibility');
                break;
            case 'ctrreport':
                navigate('/rep-ctr');
                break;
            case 'lrsreport':
                navigate('/rep-lrs');
                break;
            case 'repinsurance':
                navigate('/rep_insurance');
                break;
            case 'reppositionsummary':
                navigate('/rep_position_summary');
                break;
            case 'tranadiiinward':
                navigate('/tran-adii-inward');
                break;
            case 'repoutstandingcmrpageing':
                navigate('/rep-outstanding-cmrp-ageing');
                break;
            case 'mtmreport':
                navigate('/rep_mtm');
                break;
            case 'transactionmisreport':
                navigate('/rep_transaction-mis');
                break;
            case 'repremittencetour':
                navigate('/rep-remittence-tour');
                break;
            case 'reppurchasesale':
                navigate('/rep-purchase-sale');
                break;
            case 'transcanningreport':
                navigate('/tran-scanning-report');
                break;
            case 'tranmodificationdsrder':
                navigate('/tran-modification-dsr/der');
                break;
            case 'principlemodule':
                navigate('/principle-module');
                break;
            case 'fundtransfer':
                navigate('/fundtransfer');
                break;
            case 'airline':
                navigate('/airline');
                break;
            case 'PANWhitelisting':
                navigate('/pan-whitelisting');
                break;
            case 'commissionreport':
                navigate('/commission-report');
                break;
            case 'tranmodificationCardExecutivePurpose':
                navigate('/modification-card-executive-purpose');
                break;
            case 'rep-stock-valuation-without-comm':
                navigate('/rep-stock-valuation-without-comm');
                break;
            case 'sp-pp-modification':
                navigate('/sp-pp-modification');
                break;
            case 'rep-stock-valuation-profitability':
                navigate('/rep-stock-valuation-profitability');
                break;
            case 'crossknockoffupdated':
                navigate('/tran-cross-knockoff-updated');
                break;
            case 'faview':
                navigate('/fa-view');
                break;
            case 'principlereport':
                navigate('/rep-prinnciple');
                break;
            case 'misreport':
                navigate('/rep_mis');
                break;
            case 'pay-tution-fee':
                navigate('/pay-tution-fee');
                break;
            case 'USDConfiguration':
                navigate('/usd-configuration');
                break;
            case 'fundtransferinternal':
                navigate('/fund-transfer-internal');
                break;
            case 'expenseTran':
                navigate('/expenseTran');
                break;
            case 'tran-adi':
                navigate('/tran-adi');
                break;
            case 'master_expense':
                navigate('/master-expense');
                break;
            case 'ad2_analysis':
                navigate('/ad2-analysis');
                break;
            case 'credit_schedule':
                navigate('/credit-schedule');
                break;
            case 'awsDdataList':
                navigate('/aws-data-list');
                break;
            case 'opening_inward':
                navigate('/opening-inward-utilization');
                break;
            case 'ett-liability':
                navigate('/ett-liability');
                break;
        }
    }

    function checkNotificaiton() {
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_ACCEPT_BRANCH'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                Common.callApi(Common.apiAcceptInterBranch, [sid, 'getcount'], (result) => {
                    let resp = result;
                    if (resp * 1 > 0) {
                        setNotification(true);
                    }
                });
            }
        });
    }

    function checkSessionFinYear() {
        if (sessionStorage.getItem("sessionId")) {
            Common.callApi(Common.apiFinYear, [sessionStorage.getItem("sessionId"), "checksessionyear"], result => {
                console.log("checking session year");
                console.log(result);
                let resp = JSON.parse(result);
                if (sessionStorage.getItem('finyear') !== resp.finyear) {
                    sessionStorage.clear();
                    navigate('/');
                }
            });
        }

    }

    return (
        <>
            <div className="textRight mt-0 p-0 userStrip">
                {/* {sessionStorage.entityname}&nbsp;&nbsp;({sessionStorage.userName})&nbsp;&nbsp; */}
            </div>
            <div className="menuBar">
                <ul>
                    <li onClick={(e) => goToPage('home')} >
                        <div className="menuHomeIcon"><FontAwesomeIcon icon={faHome} className="menuIcon" />&nbsp;</div>
                    </li>
                    <li style={{ display: allRight.MASTER === "1" ? 'block' : 'none' }}>
                        <div><FontAwesomeIcon icon={faLock} className="menuIcon" />&nbsp;Master</div>
                        <div className="subMenu1">
                            <ul>
                                <li style={{ display: allRight.INDIVIDUALPROFILE === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('individualprofile')}><div>Individual Profile</div></li>
                                <li style={{ display: allRight.MASTER_RATE === "1" ? 'block' : 'none' }}>
                                    <div>Rate&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.MARGIN === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('margin')}><div>Margin</div></li>
                                            <li style={{ display: allRight.IBR === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('ibr')}><div>IBR</div></li>
                                            <li style={{ display: allRight.MASTER_DSR === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('masterdsr')}><div>DSR/DER</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.MASTER_FINANCIAL === "1" ? 'block' : 'none' }}>
                                    <div>Financial&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.MASTER_FINANCIAL_PARAMETER === "1" ? 'block' : 'none' }}>
                                                <div>Parameters&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.VOUCHERTYPE === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('vouchertype')}><div>Voucher Type</div></li>
                                                        <li style={{ display: allRight.DOCUMENTLINK === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('groupdoc')}><div>Group Document</div></li>
                                                        <li style={{ display: allRight.DEALERLIST === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('dealer')}><div>Dealer Category</div></li>
                                                        <li style={{ display: allRight.RISK === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('risk')}><div>Risk</div></li>
                                                        <li style={{ display: allRight.RISK_CONFIGURATION === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('riskconfiguration')}><div>Risk Configuration</div></li>
                                                        <li style={{ display: allRight.BUSINESSNATURE === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('businessnature')}><div>Business Nature</div></li>
                                                        <li style={{ display: allRight.LEGALSTATUS === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('legalentity')}><div>Legal Entity</div></li>
                                                        <li style={{ display: allRight.GSTCLASSIFICATION === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('gstclassification')}><div>GST Cassification</div></li>
                                                        <li style={{ display: allRight.MSME === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('msme')}><div>MSME</div></li>
                                                        <li style={{ display: allRight.MASTER_SOURCEOFFUND === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('sourceoffund')}><div>Source of Fund</div></li>
                                                        <li style={{ display: allRight.MASTER_BANKALL === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('allbank')}><div>All bank</div></li>
                                                        <li style={{ display: allRight.MASTER_BUDGET === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('masterbudget')}><div>Budget Branch</div></li>
                                                        <li style={{ display: allRight.MASTER_BUDGET === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('masterbudgetexecutive')}><div>Budget Executive</div></li>
                                                        <li style={{ display: allRight.MASTER_AIRLINE === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('airline')}><div>Airline</div></li>
                                                    </ul>
                                                </div>

                                            </li>
                                            <li style={{ display: allRight.VOUCHERGROUP === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('vouchergroup')}><div>Voucher Group</div></li>
                                            <li style={{ display: allRight.VOUCHERLEDGER === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('voucherledger')}><div>Voucher Ledger</div></li>
                                            <li style={{ display: allRight.VOUCHERLEDGERVIEW === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('voucherledgerview')}><div>Voucher Ledger View</div></li>
                                            <li style={{ display: allRight.MASTER_LEDGER_LINK === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('ledgerlink')}><div>Ledger Link</div></li>
                                            <li style={{ display: allRight.MASTER_AGENT_LINK === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('agentlinking')}><div>Agent Link</div></li>
                                            <li style={{ display: allRight.MASTER_EXPENSE === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('master_expense')}><div>Master Expense</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.MASTER_ACCESS === "1" ? 'block' : 'none' }}>
                                    <div>Access&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.RIGHT === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('right')}><div>Right</div></li>
                                            <li style={{ display: allRight.USER === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('userlist')}><div>User</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.MASTER_AREA === "1" ? 'block' : 'none' }}>
                                    <div>Area&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.REGION === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('region')}><div>Region</div></li>
                                            <li style={{ display: allRight.COUNTRYCLASS === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('countryclass')}><div>Country class</div></li>
                                            <li style={{ display: allRight.COUNTRY === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('country')}><div>Country</div></li>
                                            <li style={{ display: allRight.STATE === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('state')}><div>State</div></li>
                                            <li style={{ display: allRight.DISTRICT === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('district')}><div>District</div></li>
                                            <li style={{ display: allRight.CITY === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('city')}><div>City</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.MASTER_PARAMETER === "1" ? 'block' : 'none' }}>
                                    <div>Parameter&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className='subMenu2'>
                                        <ul>
                                            <li style={{ display: allRight.DIVISION === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('division')}><div>Division</div></li>

                                            <li style={{ display: allRight.COSTCENTER === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('costcenter')}><div>Cost Center</div></li>

                                            <li style={{ display: allRight.DESIGNATION === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('designation')}><div>Designation</div></li>
                                            <li style={{ display: allRight.EXECUTIVE === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('executive')}><div>Executive</div></li>
                                            <li style={{ display: allRight.SUB_EXECUTIVE === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('sub_executive')}><div>Sub Executive</div></li>
                                            <li style={{ display: allRight.MASTER_RESIDENTIAL === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('residentialstatus')}><div>Residential Status</div></li>
                                            <li style={{ display: allRight.CURRENCY === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('currency')}><div>Currency</div></li>
                                            <li style={{ display: allRight.PURPOSE === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('purpose')}><div>Purpose</div></li>
                                            <li style={{ display: allRight.ISSUER === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('issuer')}><div>Issuer</div></li>
                                            <li style={{ display: allRight.IDTYPE === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('idtype')}><div>ID type</div></li>
                                            <li style={{ display: allRight.MASTER_VISATYPE === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('mastervisatype')}><div>Visa Type</div></li>

                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.ENTITY === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('entity')}><div>Entity</div></li>
                                <li style={{ display: allRight.USER === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('finyear')}><div>Fin Year</div></li>
                                <li style={{ display: allRight.USER === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('sampleform')}><div>Sample</div></li>
                                <li style={{ display: allRight.MCREDITSCHEDULE === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('credit_schedule')}><div>Card Schedule</div></li>

                                <li style={{ display: allRight.AWS_DOC_LIST === "1" ? 'block' : 'none' }}
                                    onClick={(e) => goToPage('awsDdataList')}><div>AWS Doc list</div>
                                </li>


                            </ul>
                        </div>
                    </li>
                    <li style={{ display: allRight.TRANSACTION === "1" ? 'block' : 'none' }} >
                        <div>
                            <FontAwesomeIcon icon={faRectangleList} className="menuIcon" />&nbsp;Transaction</div>
                        <div className="subMenu1">
                            <ul>
                                <li style={{ display: allRight.TRAN_PURCHASES === "1" ? 'block' : 'none' }}>
                                    <div>Purchases&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.TRAN_PP === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('purchasepublic')}><div>From public</div></li>
                                            <li style={{ display: allRight.TRAN_VTM_REQUEST === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('vtmencash')}><div>VTM Encashment</div></li>
                                            <li style={{ display: allRight.TRAN_PB === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('purchasebulk')}><div>Bulk</div></li>
                                            <li style={{ display: allRight.TRAN_PI === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('purchaseinvoice')}><div>Invoice</div></li>
                                            <li style={{ display: allRight.TRAN_SETTLEMENT_VTM === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('settlement-vtm')}><div>Settlement VTM</div></li>
                                            <li style={{ display: allRight.TRAN_GL_SETTLEMENT_VTM === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('globalvtmsettle')}><div>Global Settl. VTM</div></li>
                                            {/*<li style={{ display: allRight.PURCHASE_ADII === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('purchaseadII')}><div>AD II</div></li> */}
                                            <li style={{ display: allRight.PURCHASE_ADII === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tranadiiinward')}><div>AD II Inward</div></li>


                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.TRAN_SALES === "1" ? 'block' : 'none' }}>
                                    <div>Sales&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.TRAN_SP === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('salespublic')}><div>Public</div></li>
                                            <li style={{ display: allRight.TRAN_SB === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('salebulk')}><div>Bulk</div></li>
                                            <li style={{ display: allRight.TRAN_EVTM_SURRENDER === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('evtmsurrender')}><div>EVTM Surrender</div></li>
                                            <li style={{ display: allRight.TRAN_SI === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('saleinvoice')}><div>Invoice</div></li>
                                            <li style={{ display: allRight.TRAN_VTM_ACTIVATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('vtmactivation')}><div>VTM Activation</div></li>
                                            <li style={{ display: allRight.SALES_ADII === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('salesad2')}><div> AD II </div></li>
                                            <li style={{ display: allRight.TRAN_EXPENSE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('expenseTran')}><div>ExpenseTran</div></li>

                                        </ul>
                                    </div>
                                </li>

                                <li style={{ display: allRight.TRAN_VOUCHER === "1" ? 'block' : 'none' }}>
                                    <div>Voucher&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.TRAN_BOOK_ENTRY === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('fa-book-entry')}><div>FA Book</div></li>
                                            <li style={{ display: allRight.INTER_BRANCH_ENTRY === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('ib-entry')}><div>IB Entry</div></li>
                                            <li style={{ display: allRight.TRAN_CROSS_KNOCKOFF === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('crossknockoff')}><div>Cross Knockoff</div></li>
                                            <li
                                                style={{ display: allRight.TRAN_CROSS_KNOCKOFF_UPDATED === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('crossknockoffupdated')}><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>Cross Knockoff<span className="new-badge-animated">NEW</span></div>
                                            </li>
                                            <li style={{ display: allRight.FUND_TRANSFER_INTERNAL === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('fundtransferinternal')}><div>Fund Transfer Internal</div></li>
                                            <li style={{ display: allRight.TRAN_KNOCKOFF_VIEW === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('knockoffview')}><div>Knockoff View</div></li>
                                            <li style={{ display: allRight.FA_VIEW === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('faview')}><div>FA View</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.TRAN_TRF === "1" ? 'block' : 'none' }}>
                                    <div>Transfer In &nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.TRAN_CURRENCY_IN_VIEW === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('currency-in-view')}><div>CN From Branch</div></li>
                                            <li style={{ display: allRight.TRAN_TRF_VTC === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('transfer-vtc')}><div>VTM From Issuer</div></li>
                                            <li style={{ display: allRight.TRAN_VTM_IN_VIEW === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('vtm-in-view')}><div>VTM From Branch  </div></li>
                                            <li style={{ display: allRight.TRAN_TRF_MANUAL_BOOK === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('manual-book')}><div>Manual Book</div></li>
                                            <li style={{ display: allRight.BANK_TRANSFER_IN === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('chequebookin')}><div>Cheque From Bank</div></li>
                                            <li style={{ display: allRight.TRAN_CHEQUE_IN_VIEW === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('cheque-in-view')}><div>Cheque From Branch  </div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.TRAN_TRF_OUT === "1" ? 'block' : 'none' }}>
                                    <div>Transfer Out &nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.TRAN_TRF_OUT_CURRENCY === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('transeroutcurrency')}><div>CN To Branch</div></li>
                                            <li style={{ display: allRight.TRAN_TRF_OUT_VTC === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('transferoutvtc')}><div>VTM To Branch</div></li>
                                            <li style={{ display: allRight.TRAN_TRF_OUT_ISSUER_VTC === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('transferoutissuervtc')}><div>VTM To Issuer</div></li>
                                            <li style={{ display: allRight.BANK_TRANSFER_OUT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('chequebookout')}><div>Cheque To Branch</div></li>

                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.TRAN_OPENING === "1" ? 'block' : 'none' }}>
                                    <div>Opening&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.TRAN_FINANCIAL === "1" ? 'block' : 'none' }}><div>Financial&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.TRAN_OPN_TRIAL === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('trial')}><div>Trial</div></li>
                                                        <li style={{ display: allRight.TRAN_OPN_CMRCMP === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('cmrcmp')}><div>CMR/CMP</div></li>
                                                        <li style={{ display: allRight.OPN_BANK_STATEMENT === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('bankstatement')}><div>Bank Statement</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li style={{ display: allRight.TRAN_OPN_STOCK === "1" ? 'block' : 'none' }}><div>Stock&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.TRAN_CURRENCY_STOCK === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('stock')}><div>Currency Stock</div></li>
                                                        <li style={{ display: allRight.TRAN_OPN_VTC === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('vtm')}><div>VTM In Stock</div></li>
                                                        <li style={{ display: allRight.TRAN_OPN_TC === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('tc')}><div>TC</div></li>
                                                        <li style={{ display: allRight.TRAN_OPN_ETC === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('etc')}><div>ETC</div></li>
                                                        <li style={{ display: allRight.TRAN_OPN_EVTM === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('evtm')}><div>EVTM HO</div></li>
                                                    </ul>
                                                </div>
                                            </li>

                                            <li style={{ display: allRight.TRAN_OPN_LIABILITY === "1" ? 'block' : 'none' }}><div>Liability&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.TRAN_OPN_TC_SETTLEMENT === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('tc-settlement')}><div>TC Settlement</div></li>
                                                        <li style={{ display: allRight.TRAN_OPN_VTM_SETTLEMENT === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('vtm-settlement')}><div>VTM Settlement HO</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.OTHERS === "1" ? 'block' : 'none' }}>
                                    <div>Others&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.FUND_TRANSFER === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('fundtransfer')}><div>Fund Transfer</div></li>
                                            <li style={{ display: allRight.PRINCIPLE_MODULE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('principlemodule')}><div>Principle Module</div></li>
                                            <li style={{ display: allRight.TRAN_ACCEPT_BRANCH === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('acceptinterbranch')}><div>Accept Inter Branch</div></li>
                                            <li style={{ display: allRight.CURRENCY_WRITE_OFF === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('currencywriteoff')}><div>Currency Write Off</div></li>
                                            <li style={{ display: allRight.CURRENCY_CHANGE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('currencychange')}><div>Currency Change</div></li>
                                            <li style={{ display: allRight.EXPENSE_TRANSFER === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('expense-transfer')}><div>Expense Transfer</div></li>
                                            <li style={{ display: allRight.INTERNAL_FUND_TRANSFER === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('internal-fund-transfer')}><div>Internal Fund Transfer</div></li>
                                            <li style={{ display: allRight.TRAN_COMMISSION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('commission')}><div>Commission</div></li>
                                            <li style={{ display: allRight.TRAN_CONVEYANCE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('conveyance')}><div>Conveyance Entry</div></li>
                                            <li style={{ display: allRight.TRAN_MODULE_PAYMENT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tranmodulepayment')}><div>Payment Module</div></li>
                                            <li style={{ display: allRight.TRAN_ADDITIONAL_CREDIT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('additionallimit')}><div>Additional Limit</div></li>
                                            <li style={{ display: allRight.TRAN_SANCTIONS_APPROVAL === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('sanctionsapproval')}><div>Sanctions Approval</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.TRAN_UTILITY === "1" ? 'block' : 'none' }}>
                                    <div>Utility&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.TRAN_DATA_UNLOCK === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('dataunlock')}><div>Data Unlock</div></li>
                                            <li style={{ display: allRight.CANCELLATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('cancellation')}><div>Cancellation</div></li>
                                            <li style={{ display: allRight.TRAN_PAN_WHITELIST === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('PANWhitelisting')}><div>PAN Whitelisting</div></li>
                                            <li style={{ display: allRight.TRAN_USD_CONFIGURATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('USDConfiguration')}><div>USD Configuration</div></li>
                                            <li style={{ display: allRight.TRAN_MODIFICATION === "1" ? 'block' : 'none' }}>
                                                <div>Modification&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className="subMenu2">
                                                    <ul>
                                                        {/* <li style={{ display: allRight.TRAN_MODIFICATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('transactionmodification')}><div>Modification change </div></li>
                                                        <li style={{ display: allRight.TRAN_MODIFICATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tranmodificationdate')}><div>Date</div></li> */}
                                                        <li style={{ display: allRight.COMMISSION_MODIFICATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tranmodificationcommission')}><div>Commission</div></li>
                                                        <li style={{ display: allRight.TRAN_PAYMENT_MODIFICATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tranmodificationpayment')}><div>Payment</div></li>
                                                        <li style={{ display: allRight.TRANSACTION_MODIFICATION_DSR_DER === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tranmodificationdsrder')}><div>Dsr/Der</div></li>
                                                        <li style={{ display: allRight.TRANSACTION_MODIFICATION_CARD_EXECUTIVE_PURPOSE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tranmodificationCardExecutivePurpose')}><div>Card/Executive/Purpose</div></li>
                                                        <li style={{ display: allRight.SP_PP_MODIFICATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('sp-pp-modification')}><div>SP/PP Modification</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                <li style={{ display: allRight.FUND_CONFIRMATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('fundConfirmation')}>
                                    <div>Fund Confirmation</div>
                                </li>
                                <li style={{ display: allRight.TRAN_ADI === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tran-adi')}>
                                    <div>ADI</div>
                                </li>
                                <li style={{ display: allRight.FX_DOCUMENT_UPLOAD === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('fxdocument')}>
                                    <div>Fx Document Upload</div>
                                </li>
                                <li style={{ display: allRight.TRAN_CONVERA === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('pay-tution-fee')}>
                                    <div>Convera Payment</div>
                                </li>

                            </ul>
                        </div>
                    </li>
                    <li style={{ display: allRight.BANK === "1" ? 'block' : 'none' }} >
                        <div><FontAwesomeIcon icon={faBuildingColumns} className="menuIcon" />&nbsp;Bank</div>
                        <div className="subMenu1">
                            <ul>
                                <li style={{ display: allRight.BANK_RECONCILIATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('bankreconciliation')}><div>Bank Reconciliation</div></li>
                                <li style={{ display: allRight.BANK_CHEQUES === "1" ? 'block' : 'none' }}>
                                    <div>Cheques&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.CHEQUE_DEPOSIT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('chequedeposit')}><div>Cheque Deposit </div></li>
                                            <li style={{ display: allRight.RECEIVED_CHEQUE_BOUNCE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('chequebounce')}><div>Received Cheque Bounce</div></li>
                                            <li style={{ display: allRight.ISSUE_CHEQUE_BOUNCE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('issuechequebounce')}><div>Issue Cheque Bounce</div></li>

                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li style={{ display: allRight.REPORTS === "1" ? 'block' : 'none' }} >
                        <div><FontAwesomeIcon icon={faChartLine} className="menuIcon" />&nbsp;Reports</div>
                        <div className="subMenu1">
                            <ul>
                                <li style={{ display: allRight.REPORTS_MIS === "1" ? 'block' : 'none' }}>
                                    <div>MIS&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.PRINCIPLE_REPORT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('principlereport')}><div>Principle Report</div></li>
                                            <li style={{ display: allRight.AUTOREPORT_MIS === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('misreport')}><div>MIS Report</div></li>
                                            <li style={{ display: allRight.REPORTS_MIS_CURRENCY === "1" ? 'block' : 'none' }}>
                                                <div>Currency&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className="subMenu2">
                                                    <ul>
                                                        <li style={{ display: allRight.STOCK_IN_HAND_REPORT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('stockinhandreport')}><div>Stock in Hand Report</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li style={{ display: allRight.REPORTS_MIS_VTM === "1" ? 'block' : 'none' }}><div>VTM&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.REP_MIS_VTM_UTILIZATION === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('vtmutilization')}><div>VTM Utilization</div></li>
                                                        <li style={{ display: allRight.REP_VTM_IN_OUT === "1" ? 'block' : 'none' }} a
                                                            onClick={(e) => goToPage('vtminout')}><div>VTM In Out</div></li>
                                                        <li style={{ display: allRight.REP_MIS_VTM_STATUS === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('vtmstatusreport')}><div>Status Report</div></li>
                                                        <li style={{ display: allRight.REP_MIS_VTM_FOR_SETTLEMENT_GLOBAL === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('vtmsettlementreportglobal')}><div>HO VTM/EVTM For Settlement</div></li>
                                                        <li style={{ display: allRight.REP_MIS_VTM_FOR_SETTLEMENT_LOCAL === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('vtmsettlementreportlocal')}><div>Branch VTM/EVTM For Settlement</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            {/* TT module */}
                                            <li style={{ display: allRight.REP_MIS_TT === "1" ? 'block' : 'none' }}><div>TT&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.REP_TT_OPENING_INWARD_UTILIZATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('opening_inward')}>
                                                            <div>Opening Inward Utilization</div>
                                                        </li>
                                                        <li style={{ display: allRight.REP_ETT_LIABILITY === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('ett-liability')}>
                                                            <div>ETT LIABILITY</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            {/* TT module */}
                                            <li style={{ display: allRight.TRANSACTION_REPORT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('transactionreport')}><div>Transaction</div></li>
                                            <li style={{ display: (allRight.REP_DASHBOARD === "1") ? 'block' : 'none' }} onClick={(e) => goToPage('repdashboard')}><div>Dashboard</div></li>
                                            <li style={{ display: allRight.MANUAL_BOOK_REPORT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('manualbookreport')}><div>Manual Book Report</div></li>
                                            <li style={{ display: allRight.REP_COMMISSION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('commissionreport')}><div>Commission Report</div></li>
                                            <li style={{ display: allRight.REP_MTM_HO === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('mtmreport')}><div>MTM HO </div></li>
                                            <li style={{ display: allRight.REP_TRAN_MIS_HO === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('transactionmisreport')}><div>Transaction MIS HO</div></li>
                                            <li style={{ display: allRight.REP_LRS === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('lrsreport')}><div>LRS Report</div></li>
                                            <li style={{ display: allRight.REP_INSURANCE === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('repinsurance')}><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>Insurance Report<span className="new-badge-animated">NEW</span></div>
                                            </li>
                                            <li style={{ display: allRight.REP_POSITION_SUMMARY === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('reppositionsummary')}><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>Position Summary Report<span className="new-badge-animated">NEW</span></div>
                                            </li>
                                            <li style={{ display: allRight.REP_TELLER_SHEET === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tellersheet')}><div>Teller Sheet</div></li>
                                            <li style={{ display: allRight.REP_PROFITABILITY === "1" ? 'block' : 'none' }}><div>Profitability&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.REP_PROFITABILITY_TRANSACTION === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repprofitabilitytransaction')}><div>Transaction</div></li>
                                                        <li style={{ display: allRight.REP_PROFITABILITY_CONTRIBUTION === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repprofitabilitycontribution')}><div>Contribution</div></li>
                                                        <li style={{ display: allRight.REP_VTM_PROFITABILITY_LOCAL === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repvtmprofitabilitylocal')}><div>VTM Branch</div></li>
                                                        <li style={{ display: allRight.REP_VTM_PROFITABILITY_GLOBAL === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repvtmprofitabilityglobal')}><div>VTM HO</div></li>
                                                        <li style={{ display: allRight.REP_ADII_ANALYSIS === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('ad2_analysis')}><div>Ad-II Analysis</div></li>
                                                    </ul>y

                                                </div>
                                            </li>
                                            <li style={{ display: allRight.TRAN_PAYMENT_REPORT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tranpaymentreport')}><div>Tran Payment Report</div></li>
                                            <li style={{ display: allRight.TRAN_AUDIT_TRAIL === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('activityreport')}><div>Audit Report</div></li>
                                            <li style={{ display: allRight.REP_REMITTENCE_TOUR === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('repremittencetour')}><div>Remittence Tour Report</div></li>
                                            <li style={{ display: allRight.REP_PURCHASE_SALE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('reppurchasesale')}><div>Purchase Sale Report</div></li>

                                            <li style={{ display: allRight.TRANSACTION_SCANNING_REPORT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('transcanningreport')}><div>Transaction Scanning Report</div></li>

                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.REPORTS_FINANCIAL === "1" ? 'block' : 'none' }}>
                                    <div>Financial&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.REP_LEDGER === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('ledger')}><div>Ledger</div></li>
                                            <li style={{ display: allRight.TRIAL_BALANCE === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('trialbalance')}><div>Trial Balance</div></li>
                                            {/* <li style={{ display: allRight.REP_KNOCKOFF === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('knockoffreport')}><div>Knock Off Report</div></li> */}

                                            <li style={{ display: (allRight.REP_BALANCE_SHEET === "1" && balanceSheetRight.query === "1" && balanceSheetRight.add === "1") ? 'block' : 'none' }} onClick={(e) => goToPage('balancesheet')}><div>Balance Sheet</div></li>
                                            <li style={{ display: allRight.REP_VALUATION === "1" ? 'block' : 'none' }}><div>Valuation&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>

                                                        <li style={{ display: allRight.REP_STOCK_VALUATION === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('stockvaluation')}><div>Stock Valuation</div></li>
                                                        <li style={{ display: allRight.REP_STOCK_VALUATION_WITHOUT_COMM === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('rep-stock-valuation-without-comm')}><div>Stock Valuation Without Commission</div></li>
                                                        <li style={{ display: allRight.REP_STOCK_VALUATION_PROFITABILITY === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('rep-stock-valuation-profitability')}><div>Stock Valuation Profitability</div></li>
                                                        <li style={{ display: allRight.REP_VALUATION_GLOBAL === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('repvaluationglobal')}><div>Valuation Global</div></li>
                                                        <li style={{ display: allRight.REP_VALUATION_LOCAL === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('repvaluationlocal')}><div>Valuation Local</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li style={{ display: allRight.REP_TCS === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('tcsreport')}><div>TCS Reports</div></li>
                                            <li style={{ display: allRight.REPORT_GST === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('gstreport')}><div>GST Reports</div></li>
                                            <li style={{ display: allRight.REPORTS1 === "1" ? 'block' : 'none' }}><div>Receivable&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.REP_FIN_RECV_BILL_WISE_DETAIL === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repfinrecvbillwisedetail')}><div>Bill Wise Detail</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li style={{ display: allRight.REPORTS1 === "1" ? 'block' : 'none' }}><div>Payable&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.BILL_WISE_DETAIL_PAYABLE === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('billwisedetailpayable')}><div>Bill Wise Detail</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li style={{ display: allRight.REPORT_CHEQUE === "1" ? 'block' : 'none' }}><div>Cheque&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.REP_CHEQUE_UTILIZATION === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repchequeutilization')}><div>Cheque Utilization</div></li>
                                                        <li style={{ display: allRight.REP_CHEQUE_RECEIVED === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repchequereceived')}><div>Cheque Received</div></li>
                                                        <li style={{ display: allRight.REP_CHEQUE_STATUS === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repchequestatus')}><div>Cheque Status</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li style={{ display: allRight.REPORTS_TDS === "1" ? 'block' : 'none' }}><div>Commission&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.REPORTS_TDS_COMMISSION === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('commissiontds')}><div>TDS</div></li>
                                                        <li style={{ display: allRight.REP_COMMISSION_VIEW === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repcommissionstatus')}><div>Status Report</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li style={{ display: allRight.REP_FIN_OUTSTANDING === "1" ? 'block' : 'none' }}><div>Outstanding&nbsp;
                                                <FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                                <div className='subMenu3'>
                                                    <ul>
                                                        <li style={{ display: allRight.REP_FIN_OUTSTANDING_CMRP === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repoutstandingcmrp')}><div>CMR/CMP</div></li>
                                                        <li style={{ display: allRight.REP_FIN_OUTSTANDING_CMRP_AGEING === "1" ? 'block' : 'none' }}
                                                            onClick={(e) => goToPage('repoutstandingcmrpageing')}><div>Ageing</div></li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li style={{ display: allRight.TCS_ELIGIBILITY === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('tcseligibiliy')}><div>TCS Eligibility</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.REPORTS_RBI === "1" ? 'block' : 'none' }}>
                                    <div>RBI&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.REPORTS_RBI_FLM === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('flmreport')}>
                                                <div>FLMs</div>
                                            </li>
                                            <li style={{ display: allRight.REPORTS_RBI_PURCHASE_STATEMENT === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('rbipurchasestatementreport')}>
                                                <div>RBI Purchase Statement</div>
                                            </li>
                                            <li style={{ display: allRight.REPORTS_RBI_TURNOVER_ADII === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('rbiturnoverreport')}>
                                                <div>RBI Turnover ADII</div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                {/* <li style={{ display: allRight.REPORT_HO === "1" ? 'block' : 'none' }}>
                                    <div>HO REPORT&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                        </ul>
                                    </div>
                                </li> */}
                                <li style={{ display: allRight.REPORTS_STATUTORY === "1" ? 'block' : 'none' }}>
                                    <div>Statutory&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.REP_SFTP === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('sftpreport')}><div>SFT</div></li>
                                            <li style={{ display: allRight.REP_CTR === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('ctrreport')}><div>CTR </div></li>
                                            <li style={{ display: allRight.MASTER_SANCTIONS_HEADER === "1" ? 'block' : 'none' }}
                                                onClick={(e) => goToPage('mastersanctionheader')}><div>Sanction List</div></li>
                                            <li style={{ display: allRight.REPORTS1 === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('home')}><div>Dummy</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.REPORTS === "1" ? 'block' : 'none' }}>
                                    <div>Pop Out&nbsp;<FontAwesomeIcon className="arrowIcon" icon={faCircleRight} /></div>
                                    <div className="subMenu2">
                                        <ul>
                                            <li style={{ display: allRight.REP_STOCK_VALUATION === "1" ? 'block' : 'none' }} onClick={() => setShowStockValuation(true)}><div>Stock Valuation</div></li>
                                        </ul>
                                    </div>
                                </li>
                                <li style={{ display: allRight.REPORTS_RATE_CARD === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('ratecard')}>
                                    <div> Rate Card</div>
                                </li>
                            </ul>
                        </div>
                    </li>
                    {
                        notification ? <>
                            <li style={{ display: allRight.REPORTS === "1" ? 'block' : 'none' }} >
                                <div><FontAwesomeIcon icon={faBell} className="menuIconRed" /></div>
                                <div className="subMenu1">
                                    <ul>
                                        <li style={{ display: allRight.TRAN_ACCEPT_BRANCH === "1" ? 'block' : 'none' }} onClick={(e) => goToPage('acceptinterbranch')}><div>Accept Inter Branch</div></li>
                                    </ul>
                                </div>
                            </li>
                        </> : null
                    }

                    <li
                        style={{ display: allRight.REP_STOCK_VALUATION === "1" && "1" === "2" ? 'block' : 'none' }}
                        onClick={() => setShowStockValuation(true)}>
                        <div>Stock valuation</div>
                    </li>
                    <li style={{ display: 'block', right: '0', position: 'absolute' }} >
                        <div className="menuProfileIcon"><FontAwesomeIcon icon={faUser} /></div>
                        <div className="subMenu1">
                            <ul>
                                <li style={{ display: 'block' }} onClick={(e) => goToPage(0)}><div>Log Out</div></li>
                                <li style={{ display: 'block' }} onClick={(e) => goToPage('chngpass')}><div>Change Password</div></li>
                                <li style={{ display: 'block' }} onClick={(e) => goToPage('finyear')}><div>Change Fin Year</div></li>
                            </ul>
                        </div>
                    </li>
                    {
                        /*
                            <li style={{ display: 'block', right: '0', position: 'absolute' }} onClick={(e) => goToPage(0)}><div className="menuHomeIcon"><FontAwesomeIcon icon={faDoorOpen} className="menuIcon" />&nbsp;</div></li>
                        */
                    }
                </ul>
            </div>


            {
                /*    allRight.REP_STOCK_VALUATION === "1" ? <>
     
                        <Badge bg="secondary" className="handCursor" onClick={() => setShowStockValuation(true)}>Stock Valuation</Badge>
     
                    </> : null*/
            }

            {
                showStockValuation && <Stock_valuation_model showStockValuation={showStockValuation} setShowStockValuation={setShowStockValuation} />
            }
        </>
    )
}

export default Menu
